// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upgrade-firmware-labels .label{margin-left:3px;font-size:100%}\n", "",{"version":3,"sources":["webpack://./src/styles/upgrade-firmware-labels.scss"],"names":[],"mappings":"AAAA,gCAEI,eAAgB,CAChB,cAAe","sourcesContent":[".upgrade-firmware-labels {\n  .label {\n    margin-left: 3px;\n    font-size: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
